import Icon1 from "./aiFeaturesSvg/icon1";
import Icon2 from "./aiFeaturesSvg/icon2";
import Icon3 from "./aiFeaturesSvg/icon3";
import Icon4 from "./aiFeaturesSvg/icon4";
import Icon5 from "./aiFeaturesSvg/icon5";
import Icon6 from "./aiFeaturesSvg/icon6";
import Icon7 from "./aiFeaturesSvg/icon7";
import Icon8 from "./aiFeaturesSvg/icon8";
import InstagramIcon from "./footerSvg/instagramIcon";
import LinkedinIcon from "./footerSvg/linkedinIcon";
import TwitterIcon from "./footerSvg/facebook";
import  ArrowLine  from "./line";
import HeroIcon from "./heroIcon";
import Icon_1 from "./speedIntroSvg/Icon_1";
import Icon_2 from "./speedIntroSvg/Icon_2";
import Icon_3 from "./speedIntroSvg/Icon_3";
import Icon_4 from "./speedIntroSvg/Icon_4";
import Icon_5 from "./speedIntroSvg/Icon_5";



export {Icon1,Icon2,Icon3,Icon4,Icon5,Icon6,Icon7,Icon8,InstagramIcon,LinkedinIcon,TwitterIcon,ArrowLine,HeroIcon,Icon_1,Icon_2,Icon_3,Icon_4,Icon_5}